import axios from 'axios';
import Auth from './auth';

const storageKey = 'mgc-self-link-attempt';
const authenticated = () => ({ headers: { Authorization: `Bearer ${Auth.getToken()}` } });

export async function linkingStatus() {
  const { data } = await axios.post('/sso/link', { action: 'status' }, authenticated());
  return data;
}

export async function beginLink(reauthToken) {
  const { data } = await axios.post('/sso/link', { action: 'begin', reauthToken }, authenticated());
  const target = new URL(data.authorizeUrl);
  const expected = new URL(process.env.VUE_APP_IDENTITY_DOMAIN);
  if (target.protocol !== 'https:' || target.origin !== expected.origin || target.pathname !== '/oauth2/authorize') {
    throw new Error('University sign-in returned an unexpected address. Contact your MGC administrator.');
  }
  const account = Auth.getPayload();
  sessionStorage.setItem(storageKey, JSON.stringify({
    state: data.state, browserProof: data.browserProof,
    userId: account.sub, tenant: account.tenant, startedAt: Date.now(),
  }));
  window.location.assign(target.toString());
}

export function isLinkCallback() {
  return (new URL(window.location.href).searchParams.get('state') || '').startsWith('mgclink_');
}

function savedAttempt() {
  let saved;
  try { saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) { saved = null; }
  const actor = Auth.getPayload();
  if (!saved || saved.userId !== actor.sub || saved.tenant !== actor.tenant
    || Date.now() - saved.startedAt > 600000) {
    sessionStorage.removeItem(storageKey);
    const error = new Error('The connection was cancelled or expired. Your existing login is unchanged. Start again from your account.');
    error.code = 'LINK_INTERRUPTED';
    throw error;
  }
  return { state: saved.state, browserProof: saved.browserProof };
}

export async function prepareLink() {
  const callback = new URL(window.location.href);
  const saved = savedAttempt();
  // Retain only state so a refresh can reload the server's verified review.
  window.history.replaceState({}, '', `/admin/sso/callback?state=${encodeURIComponent(saved.state)}`);
  if (saved.state !== callback.searchParams.get('state') || callback.searchParams.get('error')) {
    sessionStorage.removeItem(storageKey);
    const error = new Error('The connection was cancelled or expired. Your existing login is unchanged. Start again from your account.');
    error.code = 'LINK_INTERRUPTED';
    throw error;
  }
  const { data } = await axios.post('/sso/link', {
    action: 'prepare', ...saved, code: callback.searchParams.get('code'),
  }, authenticated());
  return data;
}

export async function confirmLink() {
  const { data } = await axios.post('/sso/link', { action: 'confirm', ...savedAttempt() }, authenticated());
  if (data.linked !== true) throw new Error('Connection status is unavailable.');
  sessionStorage.removeItem(storageKey);
  return data;
}

export async function cancelLink() {
  const { data } = await axios.post('/sso/link', { action: 'cancel', ...savedAttempt() }, authenticated());
  if (data.cancelled !== true) throw new Error('Cancellation could not be confirmed.');
  sessionStorage.removeItem(storageKey);
  return data;
}
